import { useEffect, useMemo, useState, useRef } from "react"
import { Link, useLocation, useHistory } from "react-router-dom"
import { Input, Button, Table, Select, DatePicker, Space, Row, Col, Statistic, message } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: string | undefined,
    customer_name: string | undefined,
    customer_phone: number | undefined,
    preg_status: number | undefined,
    expectBornDay: any,
    service_status: number | undefined,
    serviceDay: any,
    belong_nursing_id: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

// 统计汇总
type summaryNum = {
    all_customer?: any, // 全部客户,
    wait_distribute_customer?: any, // 待分配客户
    wait_up_order_customer?: any, // 待上户客户
    wait_down_order_customer?: any, // 待下户客户
    allocated_customer?: any, // 已分配客户
    month_wait_born_customer?: any, // 本月待产客户
    month_wait_born_distribute_customer?: any // 本月待产待分配
}

interface ep {
    "employee_id": string,
    "user_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        customer_name: undefined,
        customer_phone: undefined,
        preg_status: undefined,
        expectBornDay: null,
        service_status: undefined,
        serviceDay: null,
        belong_nursing_id: undefined
    }

    // 统计汇总
    const [summary, setSummary] = useState<summaryNum>({
        all_customer: 0, // 全部客户,
        wait_distribute_customer: 0, // 待分配客户
        wait_up_order_customer: 0, // 待上户客户
        wait_down_order_customer: 0, // 待下户客户
        allocated_customer: 0, // 已分配客户
        month_wait_born_customer: 0, // 本月待产客户
        month_wait_born_distribute_customer: 0 // 本月待产待分配
    })

    // 顶部按钮类型
    const btnTypeRef = useRef<number>(0);

    // 列表数据
    const [data, setData] = useState<any>([])
    // 列表Loading
    const [loading, setLoading] = useState<boolean>(false)

    const History = useHistory()
    const Location: any = useLocation()

    const [epData, setEpData] = useState<ep[]>([])

    // 列表筛选条件设置
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(() => {
        // 回填链接传回的数值
        let stateFetchOtherParams = null
        if (Location.state && Location.state.fetchOtherParams) {
            const { fetchOtherParams } = Location.state

            if (fetchOtherParams.expectBornDay) {
                fetchOtherParams.expectBornDay[0] = moment(fetchOtherParams.expectBornDay[0])
                fetchOtherParams.expectBornDay[1] = moment(fetchOtherParams.expectBornDay[1])
            }

            if (fetchOtherParams.serviceDay) {
                fetchOtherParams.serviceDay[0] = moment(fetchOtherParams.serviceDay[0])
                fetchOtherParams.serviceDay[1] = moment(fetchOtherParams.serviceDay[1])
            }

            stateFetchOtherParams = fetchOtherParams

        } else {
            stateFetchOtherParams = fetchOtherParamsTmpl
        }

        return stateFetchOtherParams
    })

    // 列表分页
    const [pagination, setPagination] = useState<pagination>(() => {
        let statePagination = (Location.state && Location.state.pagination) ? Location.state.pagination : {
            current: 1,
            pageSize: 8,
            total: 0,
            showSizeChanger: false,
        }

        return statePagination
    })

    // 页面权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    // 加载列表数据
    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
        summaryFetch({ fetchOtherParams })
    }, [])

    // 点击顶部按钮的时候重置搜索表单
    const resetSearchForm = () => {
        History.replace({
            ...Location,
            state: null
        })

        resetForm()
    }

    // 点击顶部按钮
    const handleBtnClick = (type: any) => {
        btnTypeRef.current = type;
        resetSearchForm()
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams })
    }

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current

        let params: any = { ...fetchOtherParams }
        params.select_type = btnTypeRef.current

        handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
        handleDate(params, 'serviceDay', ['service_start_date', 'service_end_date'])

        axiosTable.get("/yuesao_center/customer/residence/page_list", {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const summaryFetch = ({ fetchOtherParams }: { fetchOtherParams: object }) => {
        let params: any = { ...fetchOtherParams }
        params.select_type = btnTypeRef.current

        handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
        handleDate(params, 'serviceDay', ['service_start_date', 'service_end_date'])

        axiosTable.get('/yuesao_center/customer/residence/summary', {
            params: {
                ...params
            }

        }).then((response: any) => {
            if (response) {
                setSummary(response)
            }
        })
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
        summaryFetch({ fetchOtherParams })
    }

    // 重置筛选
    const resetForm = () => {
        History.replace({
            ...Location,
            state: null
        })

        let params = {
            ...fetchOtherParamsTmpl,
            store_id: undefined
        }

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        setFetchOtherParams(params)

        fetch({ pagination: p, fetchOtherParams: params })
        summaryFetch({ fetchOtherParams: params })
    }

    // 导出
    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'expectBornDay', ['expect_born_start_day', 'expect_born_end_day'])
        handleDate(params, 'serviceDay', ['service_start_date', 'service_end_date'])

        baseAxiosComplete('/yuesao_center/customer/residence/export', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 客户管理 -> 到府客户管理 */}
        <BreadCrumb position={['月嫂中心', '到府客户管理']} />

        {/* 页面筛选 */}
        <div className="common-top-form">
            <Space direction="horizontal" wrap >
                {/* 页面按钮筛选 */}
                <Row gutter={20} style={{ marginBottom: 10 }}>
                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(0) }}
                            style={{ backgroundColor: btnTypeRef.current == 0 ? '#1890ff' : '', marginTop: 5 }}
                        >全部客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(1) }}
                            style={{ backgroundColor: btnTypeRef.current == 1 ? '#1890ff' : '', marginTop: 5 }}
                        >待分配客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(7) }}
                            style={{ backgroundColor: btnTypeRef.current == 7 ? '#1890ff' : '', marginTop: 5 }}
                        >待上户客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(8) }}
                            style={{ backgroundColor: btnTypeRef.current == 8 ? '#1890ff' : '', marginTop: 5 }}
                        >待下户客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(4) }}
                            style={{ backgroundColor: btnTypeRef.current == 4 ? '#1890ff' : '', marginTop: 5 }}
                        >已分配客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(5) }}
                            style={{ backgroundColor: btnTypeRef.current == 5 ? '#1890ff' : '', marginTop: 5 }}
                        >本月待产客户</Button>
                    </Col>

                    <Col>
                        <Button type="primary" onClick={() => { handleBtnClick(6) }}
                            style={{ backgroundColor: btnTypeRef.current == 6 ? '#1890ff' : '', marginTop: 5 }}
                        >本月待产待分配</Button>
                    </Col>
                </Row>
            </Space>

            <Space direction="horizontal" wrap style={{ marginTop: 10 }}>
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => {
                        handleChange(value, 'store_id')

                        baseAxiosNoInfo('/global/employee_list_by_position', {
                            params: {
                                department_id: value,
                                position_number: '21'
                            }

                        }).then((res: any) => {
                            res && setEpData(res)
                        })
                    }}
                        value={fetchOtherParams.store_id}
                    />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="客户姓名" value={fetchOtherParams.customer_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '140px' }} placeholder="客户手机号" value={fetchOtherParams.customer_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_phone') }} />

                <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="怀孕状态" value={fetchOtherParams.preg_status} onChange={(v: number) => { handleChange(v, 'preg_status') }}>
                    <Option value={1} key={1}>正在备孕</Option>
                    <Option value={2} key={2}>已经怀孕</Option>
                    <Option value={3} key={3}>已有宝宝</Option>
                    <Option value={4} key={4}>小月子</Option>
                    <Option value={5} key={5}>孕早期</Option>
                    <Option value={6} key={6}>孕中期</Option>
                    <Option value={7} key={7}>孕晚期</Option>
                    <Option value={8} key={8}>预产期前7天</Option>
                    <Option value={9} key={9}>已分娩</Option>
                    <Option value={10} key={10}>超出预产期</Option>
                    <Option value={0} key={0}>未知</Option>
                </Select>
                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 280 }}
                    placeholder={["预产期开始日期", "预产期结束日期"]}
                    value={fetchOtherParams.expectBornDay}
                    onChange={(v: any) => { handleChange(v, 'expectBornDay') }}
                />

                {
                    (btnTypeRef.current == 0 || btnTypeRef.current == 5) ? (
                        <Select allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="服务状态" value={fetchOtherParams.service_status} onChange={(v: number) => { handleChange(v, 'service_status') }}>
                            <Option value={1} key={1}>待上户</Option>
                            <Option value={2} key={2}>已上单</Option>
                            <Option value={3} key={3}>已下单</Option>
                            <Option value={0} key={0}>待分配</Option>
                        </Select>
                    ) : null
                }

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["服务开始日期", "服务结束日期"]}
                    value={fetchOtherParams.serviceDay}
                    onChange={(v: any) => { handleChange(v, 'serviceDay') }}
                />
                <Select showSearch allowClear className="fl" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: '170px' }} placeholder="护理师（先选门店）" value={fetchOtherParams.belong_nursing_id} onChange={(e: string) => { handleChange(e, 'belong_nursing_id') }} >
                    {epData.map((el: ep) => <Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && btnTypeRef.current == 0 && (<Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>)}
            </div>
        </div>

        {/* 表格展示 */}
        <div className="common-main" style={{ marginTop: '10px' }}>
            {/* 页面汇总数据 */}
            <Row gutter={[12, 12]} style={{ marginBottom: 20, marginLeft: 0 }}>
                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #1890FF',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>全部客户</div>}
                            value={summary ? summary.all_customer : 0}
                            valueStyle={{ color: '#1890FF', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #FF4D4F',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>待分配客户</div>}
                            value={summary ? summary.wait_distribute_customer : 0}
                            valueStyle={{ color: '#FF4D4F', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #FA8C16',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>待上户客户</div>}
                            value={summary ? summary.wait_up_order_customer : 0}
                            valueStyle={{ color: '#FA8C16', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #FF7A45',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>待下户客户</div>}
                            value={summary ? summary.wait_down_order_customer : 0}
                            valueStyle={{ color: '#FF7A45', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #52C41A',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>已分配客户</div>}
                            value={summary ? summary.allocated_customer : 0}
                            valueStyle={{ color: '#52C41A', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #722ED1',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>本月待产客户</div>}
                            value={summary ? summary.month_wait_born_customer : 0}
                            valueStyle={{ color: '#722ED1', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>

                <Col span={3}>
                    <div style={{
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderLeft: '3px solid #EB2F96',
                        borderRadius: '8px',
                        padding: '6px 15px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        transition: 'all 0.3s',
                        textAlign: 'center',
                    }}>
                        <Statistic
                            title={<div style={{ fontSize: '14px', color: '#666', fontWeight: 400 }}>本月待产待分配</div>}
                            value={summary ? summary.month_wait_born_distribute_customer : 0}
                            valueStyle={{ color: '#EB2F96', fontSize: '24px', fontWeight: 600 }}
                        />
                    </div>
                </Col>
            </Row>

            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey={(records) => records.id} pagination={pagination} onChange={handleTableChange}>
                <Column fixed title="操作" render={(row: any) => {
                    return permission.includes('查看') ? <Link to={(location) => {
                        let params = _.cloneDeep(fetchOtherParams)

                        if (params.expectBornDay) {
                            params.expectBornDay[0] = params.expectBornDay[0].format('YYYY-MM-DD')
                            params.expectBornDay[1] = params.expectBornDay[1].format('YYYY-MM-DD')
                        }

                        if (params.serviceDay) {
                            params.serviceDay[0] = params.serviceDay[0].format('YYYY-MM-DD')
                            params.serviceDay[1] = params.serviceDay[1].format('YYYY-MM-DD')
                        }

                        return {
                            ...location,
                            pathname: '/yuesao_residence_detail/' + row.id,
                            state: {
                                pagination: { ...pagination },
                                fetchOtherParams: { ...params }
                            }
                        }
                    }} >查看详情</Link> : null
                }} />

                <Column fixed title="客户姓名" dataIndex="customer_name" key="customer_name" />
                <Column fixed title="客户手机号" dataIndex="customer_phone" key="customer_phone" />

                <Column title="怀孕时期" dataIndex="preg_status_desc" key="preg_status_desc" />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />

                <Column title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />

                <Column title="护理师" dataIndex="service_nursing_name" key="service_nursing_name" />
                <Column title="服务开始日期" dataIndex="service_start_date" key="service_start_date" />
                <Column title="服务结束日期" dataIndex="service_end_date" key="service_end_date" />
                <Column title="服务天数" dataIndex="service_days" key="service_days" />
                <Column title="剩余天数" dataIndex="service_left_days" key="service_left_days" />
                <Column title="服务状态" dataIndex="service_status_desc" key="service_status_desc" />

                <Column title="服务信息" dataIndex="service_info" key="service_info" />
                <Column title="服务地址" dataIndex="service_address" key="service_address" />
            </Table>
        </div>
    </div>)
}